/* unplugin-vue-components disabled */import script from "./TravelOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./TravelOrder.vue?vue&type=script&setup=true&lang=js"

import "./TravelOrder.vue?vue&type=style&index=0&id=661061ef&lang=scss"

const __exports__ = script;

export default __exports__